import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { DateTimeFormat, parseMoment } from '@/shared/converters/dateConverters';
import PlanningTask from '../models/PlanningTask';
import { parseAppointment } from './appointmentConverters';
import { ABSTRACT_SCHEMA } from './taskConverters';

const SCHEMA = {
  ...ABSTRACT_SCHEMA,
  id: 'id',
  type: 'planningType',
  start: (data: any) => parseMoment(data.startsAt, DateTimeFormat.LEGACY),
  end: (data: any) => parseMoment(data.stopsAt, DateTimeFormat.LEGACY),
  appointment: parseAppointment,
};

export function parsePlanningTask(data: any): PlanningTask | null {
  return parseEntity(data, SCHEMA, PlanningTask);
}

export function parsePlanningTasks(data: any): Array<PlanningTask> {
  return parseEntities(data, parsePlanningTask);
}
